export enum BomItemTypeCategoryEnum {
  MATERIAL = 'MATERIAL',
  ACCESSORY = 'ACCESSORY',
}
